import { Html5Qrcode } from "html5-qrcode";
import React, { useEffect, useRef } from "react";
import { useAlert } from "../../contexts/alertProvider.tsx";
import { StatusCode } from "../Alert.tsx";

const ScanBarcode = ({
    handleResult,
    setShowScanBarcode,
}: {
    handleResult: (result: string) => any;
    setShowScanBarcode: (value: boolean) => void;
}) => {
    const { showAlert } = useAlert();
    const html5QrCodeRef = useRef<Html5Qrcode | null>(null);
    var lastError = '';

    useEffect(() => {
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
            showAlert(StatusCode.warning, "Camera streaming is not supported in this browser.");
            setShowScanBarcode(false);
            return;
        }

        const html5QrCode = new Html5Qrcode("reader");
        html5QrCodeRef.current = html5QrCode;
        html5QrCode
            .start(
                { facingMode: { exact: "environment" } },
                { fps: 240, qrbox: 250, aspectRatio: 1, disableFlip: true },
                (decodedText) => {
                    handleResult(decodedText);
                    setShowScanBarcode(false);
                    html5QrCode.stop();
                },
                (error) => {
                    if (error != lastError) { lastError = error; console.error("Scan error: ", error); }
                    if (error === "NotFoundException") {
                        showAlert(StatusCode.warning, "No code detected. Ensure it's within the scanning area.");
                    }
                }
            )
            .catch((err) => {
                console.error("Failed to start scanner", err);
                showAlert(StatusCode.warning, "Failed to access the camera.");
                setShowScanBarcode(false);
            });

        return () => {
            if (html5QrCodeRef.current?.isScanning)
                html5QrCodeRef.current.stop().catch((err) => console.error("Failed to stop scanner", err));
        };
    }, [setShowScanBarcode, showAlert]);

    return (
        <div className="w-100 position-relative">
            <button
                style={{ zIndex: 999999997 }}
                type="button"
                className="btn btn-secondary position-absolute top-0 end-0 py-0 px-1 m-2"
                onClick={() => setShowScanBarcode(false)}
            >
                <h1 className="m-0"><i className="bi bi-x" /></h1>
            </button>
            <div id="reader" className="w-100" />
        </div>
    );
};

export default ScanBarcode;
